/* eslint-disable react/prop-types */
import styled from '@emotion/styled';
import { Button } from 'roo-ui/components';

const SkipToContentButton = styled(Button)`
  opacity: 0;
  pointer-events: none;
  text-decoration: none;
  position: absolute;
  font-weight: initial;
  letter-spacing: initial;
  text-transform: none;

  &:focus {
    opacity: 1;
    pointer-events: auto;
  }
`;

export default SkipToContentButton;
